import * as React from 'react';
export const NumberFieldContext = /*#__PURE__*/React.createContext(null);
if (process.env.NODE_ENV !== 'production') {
  NumberFieldContext.displayName = 'NumberFieldContext';
}
export function useNumberFieldContext(part) {
  const context = React.useContext(NumberFieldContext);
  if (context === null) {
    throw new Error(`Base UI: NumberField${part} is not placed inside the NumberField component.`);
  }
  return context;
}